import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarService } from 'src/app/services/calendar.service';
import { VacationRequest } from 'src/app/models/CalendarRequest';
import { OptionSet } from 'src/app/models/OptionSet';
import { STATUS_CODES } from 'http';
import { AuthoritiesStatusDialogComponent } from '../authorities-status-dialog/authorities-status-dialog.component';
import { DataService } from 'src/app/services/data.service';
import { VacationFile } from 'src/app/models/CalendarModels';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-account-vacation-dialog',
  templateUrl: './account-vacation-dialog.component.html',
  styleUrls: ['./account-vacation-dialog.component.scss']
})

export class AccountVacationDialogComponent implements OnInit {
  formDialog: FormGroup;
  public dates: any[] = [];
  public bySector = false;
  loading: boolean = false;
  isSubmited: boolean = false;
  existingFiles: VacationFile[] = [];
  newFiles: VacationFile[] = [];

  constructor(public calendarSvc: CalendarService,
    public dialogRef: MatDialogRef<AccountVacationDialogComponent>, public statusDialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public dataService: DataService, private cookieService: CookieService) {
    this.dates = JSON.parse(JSON.stringify(this.data.dates));
    debugger
    this.formDialog = new FormGroup({
      endTime: new FormControl(),
      vacationType: new FormControl(null, Validators.required),
      description: new FormControl(null),
      isShortDay: new FormControl(false),
      Status: new FormControl(null)
      // color: new FormControl(null, Validators.required),
    });
    this.getAuthorityStatuses();
  }
  getAuthorityStatuses() {
    debugger
    if (this.data.item && this.data.item?.AuthorityStatuses == null) {
      this.calendarSvc.getAuthorityStatuses(this.data.item.VacationId, "new_holidaycalendarid").then((res: any) => {
        if (!this.calendarSvc.dataService.IsError(res)) {
          this.calendarSvc.vacations.find(x => x.VacationId == this.data.item.VacationId).AuthorityStatuses = JSON.parse(res);
          this.data.item.AuthorityStatuses = JSON.parse(res);
        }
      }).catch(err => {
        debugger
      });
    }
  }

  ngOnInit(): void {
    debugger
    if (this.data.item) {
      console.log("Item", this.data.item);
      this.formDialog.get("vacationType").setValue(this.calendarSvc.PeriodDescriptionList.find(p => p.value == this.data.item.Period.value));
      this.formDialog.get("Status").setValue(this.data.item.Status.viewValue);
      if (this.data.item.Period.viewValue == 'אחר')
        this.elseChosen = true;
      console.log(this.formDialog.value);
      this.formDialog.get("description").setValue(this.data.item.Description)
      this.formDialog.get("isShortDay").setValue(this.data.item.IsShortDay);

      if (this.data.item.EndTime) {
        this.formDialog.get("endTime").setValue(this.calendarSvc.getOption(this.data.item.EndTime.value, this.calendarSvc.ScheduleHoursList));
        this.formDialog.get("endTime").addValidators(Validators.required);
        this.formDialog.get("endTime").updateValueAndValidity();
      }
      // if (this.data.item.Color) {
      //   this.formDialog.get("color").setValue(this.calendarSvc.ColorsList.find(x => x.value == this.data.item.Color.value).viewValueEn);
      // }
      this.bySector = this.data.item.Sector;

      this.existingFiles = this.data.item.Files.map(f => ({
        FileId: f.FileId,
        FileName: f.FileName,
        Note: f.Note || ''
      }));
    }
    this.standaloneNotes = this.existingFiles
      .filter(f => f.FileName === '__STANDALONE_NOTE__.txt')
      .map(f => ({ Note: f.Note || '' }));

    this.existingFiles = this.existingFiles.filter(f => f.FileName !== '__STANDALONE_NOTE__.txt');
  }

  removeDate(value, i) {
    this.dates.splice(i, 1);
  }

  save() {
    // return;
    this.isSubmited = true;
    console.log(this.formDialog)
    if (this.formDialog.invalid) {
      alert("יש לוודא שכל הערכים תקינים");
      return;
    }
    this.calendarSvc.spinnerSubjectEmit(true);
    // this.loading = true;
    this.formDialog.disable();
    let request: VacationRequest = new VacationRequest();
    // request.Color = this.calendarSvc.ColorsList.find(x => x.viewValueEn == this.formDialog.value.color);
    request.IsShortDay = this.formDialog.value.isShortDay;
    request.StartTime = new OptionSet();
    request.StartTime.value = "800";
    request.StartTime.viewValue = "08:00";
    request.EndTime = this.formDialog.value.endTime;
    request.Description = this.formDialog.value.description;
    request.Period = this.formDialog.value.vacationType;
    let name = this.formDialog.value.vacationType.viewValue;

    if (name === 'אחר') {
      name = this.formDialog.value.description;
    }

    if (this.formDialog.value.endTime && !name.includes("יום קצר")) {
      name = "יום קצר - " + name;
    }

    if (this.dataService?.userModel?.Year?.viewValue) {
      name += `, ${this.dataService.userModel.Year.viewValue}`;
    }

    if (this.dates.length > 0) {
      const sortedDates = this.dates.map(d => new Date(d.date)).sort((a, b) => a.getTime() - b.getTime());
      const startDate = sortedDates[0].toLocaleDateString('he-IL');
      const endDate = sortedDates[sortedDates.length - 1].toLocaleDateString('he-IL');
      name += `, ${startDate} - ${endDate}`;
    }

    request.Name = name;
    request.Dates = this.dates.map(x => { return this.calendarSvc.transformDate(x.date, "yyyy-MM-dd") });
    if (this.data.item) {
      request.Id = this.data.item.VacationForAccountId;
      request.ParentId = this.data.item.VacationId;
    }

    const useLogin = this.cookieService.get('useLogin');

    if (useLogin === 'false') {
      request.lastUpdatedByName = this.cookieService.get('SystemUserFullName');;
    } else {
      request.lastUpdatedByName = this.cookieService.get('AcountFullName');;
    }
    const standaloneNotesAsFiles = this.standaloneNotes
      .filter(note => note.Note && note.Note.trim() !== '')
      .map(note => {
        const emptyFile = new File([''], '__STANDALONE_NOTE__.txt', { type: 'text/plain' });
        return {
          File: emptyFile,
          FileName: '__STANDALONE_NOTE__.txt',
          Note: note.Note
        } as VacationFile;
      });

    const allNewFiles = [...this.newFiles, ...standaloneNotesAsFiles];
    this.calendarSvc.saveVacationForAccountWithFiles(request, allNewFiles, this.existingFiles).then((res: any) => {
      this.dialogRef.close(true);
    }).catch(error => {
      this.calendarSvc.spinnerSubjectEmit(false);
      alert("ארעה שגיאה");
    });
  }

  close() {
    this.dialogRef.close(false);
  }

  OnSwitch(ischecked: boolean) {
    this.formDialog.get("isShortDay").setValue(ischecked);
    if (ischecked) {
      this.formDialog.get("endTime").addValidators(Validators.required);
    }
    else {
      this.formDialog.get("endTime").clearValidators();
      this.formDialog.get("endTime").setValue(null);
    }
    this.formDialog.get("endTime").updateValueAndValidity();
  }

  checkChosen(event: any) {
    if (!event) return;
    if (this.formDialog.value.vacationType.viewValue == 'אחר') {
      this.elseChosen = true;
      this.formDialog.get("description").addValidators(Validators.required);
    }
    else {
      this.elseChosen = false;
      this.formDialog.get("description").clearValidators();
      this.formDialog.get("description").updateValueAndValidity();
    }
  }

  elseChosen: boolean = false


  openDialog() {
    this.statusDialog.open(AuthoritiesStatusDialogComponent, {
      panelClass: 'full-width-dialog',
      hasBackdrop: true,
      autoFocus: true,
      // disableClose: true,
      data: this.data.item.AuthorityStatuses,
    });
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const filesArray = Array.from(input.files);
      for (let newFile of filesArray) {
        const existsInNewFiles = this.newFiles.some(f => f.FileName === newFile.name && f.File.size === newFile.size);
        if (!existsInNewFiles) {
          this.newFiles.push({
            File: newFile,
            FileName: newFile.name,
            Note: ''
          });
        }
      }
      input.value = '';
    }
  }

  downloadFile(fileId: string, fileName: string) {
    this.calendarSvc.downloadVacationFile(fileId).then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }

  standaloneNotes: { Note: string }[] = [];

  addStandaloneNote() {
    this.standaloneNotes.push({ Note: '' });
  }

  removeStandaloneNote(index: number) {
    this.standaloneNotes.splice(index, 1);
  }

  hasExistingStandaloneNote(): boolean {
    return this.existingFiles.some(file => !file.FileName && file.Note);
  }
}
